<template>
  <v-card id="change-appointment-modal" class="main-bg" style="background-color: white">
    <v-toolbar class="elevation-0 white" light max-height="64">
      <v-toolbar-title class="black--text"><h3>เปลี่ยนเวลานัด</h3></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="onCancel()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-container fluid class="pa-0">
        <v-row>
          <v-col cols="12" class="text-center">
            <span style="font-size: 16px;">วันนัดปัจจุบัน <span class="bc--current">{{ appointmentDisplay() }}</span></span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <date-picker v-model="appointedAtDate" :min="getMinDate()" label="วันที่นัด*"></date-picker>
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="appointedAtTime"
              :items="getTimeSlots()"
              item-text="display"
              item-value="timeSlot"
              label="เลือกเวลานัด*"
              :rules="rules.appointedAtTime"
              prepend-inner-icon="mdi-clock-outline"
              filled
            ></v-select>
          </v-col>
        </v-row>
        <v-card-actions class="pr-0 pt-10">
          <v-spacer></v-spacer>
          <v-btn :disabled="loading" class="mr-2 py-2" x-large depressed outlined height="44" color="primary" @click="onCancel()">ยกเลิก</v-btn>
          <v-btn :disabled="loading" class="py-2" x-large depressed height="44" color="primary" @click="onSubmit()">
            <v-progress-circular
              v-if="loading"
              indeterminate
              style="height: 18px; width: 18px"
            ></v-progress-circular>
            ยืนยัน</v-btn>
        </v-card-actions>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment';
import DatePicker from '@/components/DatePicker';
import { AppointmentTimeSlots } from '@/common/api/config';
import { ERROR } from '@/store/actions/ui';

export default {
  components: {
    DatePicker,
    // BookingDetailModal,
  },
  computed: {
    // ...mapGetters(['commercialServiceLoading', 'commercialServiceRating']),
    // appointmentTimeSlots: () => AppointmentTimeSlots,
  },
  watch: {
    appointedAtDate(date) {
      console.log('appointedAtDate', date);

      this.appointmentTimeSlots = AppointmentTimeSlots;

      const momentDate = moment(date).format('YYYY-MM-DD');
      // console.log('current', moment());

      // const format = 'hh:mm:ss';
      // const time = moment(moment(),'HH:mm:ss');
      // const beforeTime = moment('16:34:00');
      const time = moment();
      const afterTime = moment('2023-07-06 14:00:00');

      const isSameOrAfter = time.isSameOrAfter(afterTime);
      console.log('isSameOrAfter', isSameOrAfter);

      const timeList = this.appointmentTimeSlots.filter((slot) => {
        const max = moment(`${momentDate} ${slot.maxTimeSlot}`);

        console.log('time', time);
        console.log('max', max);

        console.log(time.isSameOrAfter(max));
        return !time.isSameOrAfter(max);
      });

      this.appointmentTimeSlots = timeList;

      console.log('timeList', timeList);

      return date;
    },
  },
  props: {
    appointment: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      appointedAtDate: null,
      appointedAtTime: null,
      appointmentTimeSlots: AppointmentTimeSlots,
      currentDate: moment().local(),
      rules: {
        appointedAtTime: [
          v => !!v || 'กรุณาเลือก เวลานัด',
        ],
      }
    };
  },
  async created() {
    // console.log('data', this.data);
    // await this.$store.dispatch(COMMERCIAL_SERVICE_VENDOR_RATING_REQUEST, this.data.objectId);

    // this.selectedChangedStatus = null;

  },
  methods: {
    getMinDate() {
      const curDate = moment();
      const maxDate = moment(moment().format('YYYY-MM-DD 16:00:00'));

      console.log(curDate, maxDate);
      console.log(curDate.isSameOrAfter(maxDate));

      const isAfterMaxDate = curDate.isSameOrAfter(maxDate);

      return isAfterMaxDate ? curDate.add(1, 'day') : curDate;
    },
    getTimeSlots() {
      return this.appointmentTimeSlots;
    },
    appointmentDisplay() {
      return moment.utc(this.appointment).local().locale('th').format('DD MMM YYYY, HH:mm น.') || '-';
    },
    onCancel() {
      this.$emit('cancelled');
    },
    onSubmit() {
      const payload = this.validate();
      console.log(payload);
      if (payload) {
        this.loading = true;
        this.$emit('saved', payload);
      }

      this.loading = false;
    },
    validate() {
      if (!this.appointedAtDate) {
        this.$store.dispatch(ERROR, 'กรุณาเลือก วันที่นัด');
        return null;
      }

      if (!this.appointedAtTime) {
        this.$store.dispatch(ERROR, 'กรุณาเลือก ช่วงเวลานัด');
        return null;
      }

      const date = moment(this.appointedAtDate).format('YYYY-MM-DD');
      const time = this.appointedAtTime;
      return `${date} ${time}`;
    },
  },
};
</script>
<style lang="scss" scope>
#change-appointment-modal {

}
</style>
